/** Pure black, to mirror onto a large display: light on dark, no chrome. */
export const workshopBoardColors = {
  background: '#000000',
  card: '#111113',
  line: '#1C1C1E',
  skeleton: '#1C1C1E',
  foreground: '#FFFFFF',
  muted: '#8E8E93',
  faint: '#48484A',
  active: '#0A84FF',
  done: '#30D158',
};
